/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaPromotionCode } from '../../models/criteria-promotion-code';
import { PromotionCode } from '../../models/promotion-code';

export interface ApiMasterPromotionCodeGetByCriteriaPost$Params {
      body?: CriteriaPromotionCode
}

export function apiMasterPromotionCodeGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterPromotionCodeGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromotionCode>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPromotionCodeGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PromotionCode>>;
    })
  );
}

apiMasterPromotionCodeGetByCriteriaPost.PATH = '/api/Master/PromotionCode/GetByCriteria';
